<template>

  <teleport to="#teleport">
    <transition name="transition-fade" appear>
      <div
        class="popup"
        ref="popupRoot"
      >
      <div class="popup-content">
        <NotificationV2NotificationPage 
          :popup="true"
          />      
        </div>
        <div class="popup-overlay" @click="$emit('close')"></div>
      </div>    
    </transition>
  </teleport>

</template>

<script setup lang="ts">
import { ref, onMounted, watch } from 'vue'
import { onClickOutside } from '@vueuse/core'
import UiButton from '~/components/ui/Button.vue'
import NotificationTabs from './NotificationTabs.vue'
import NotificationList from './NotificationList.vue'
import { usePopupPosition } from './usePopupPosition'
import { NotificationChannel } from '~/types/notification'

const router = useRouter()

const { top, right, isHidden } = usePopupPosition()
const { 
  // popupVisible, 
  tabCounts,
  loadNotificationGroups,
  initializeNotifications
} = useNotifications()
const route = useRoute()

const emits = defineEmits(['close'])

const activeTab = ref<NotificationChannel>(NotificationChannel.Direct)
const listRefDirect = ref<any>(null)
const listRefFollowing = ref<any>(null)
const listRefCommunity = ref<any>(null)
const isInitialized = ref(false)

const switchTab = (newTab: NotificationChannel) => {
  activeTab.value = newTab
}

const onListInitialized = () => {
  isInitialized.value = true
}

const markAllAsRead = () => {
  useNotifications().markAllAsRead()
  listRefDirect.value.markAllAsReadAndClear()
  listRefFollowing.value.markAllAsReadAndClear()
  listRefCommunity.value.markAllAsReadAndClear()
}

// Initialize notifications when popup is first opened
onMounted(async () => {
  if (!isInitialized.value) {
    // await initializeNotifications()
    // isInitialized.value = true
  }
})

// Close popup when clicking outside
const popupRoot = ref(null)
// onClickOutside(popupRoot, () => {
//   popupVisible.value = false
// })

watch(router.currentRoute, (newCurrentRoute, oldCurrentRoute) => {

  if(oldCurrentRoute.fullPath === newCurrentRoute.fullPath)
    return

  // if (popupVisible.value) {
  //   popupVisible.value = false
  // }
}, {deep: true})

</script>




<style scoped>
.popup{
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1000;
  display: flex;
  align-items: flex-start;
  justify-content: flex-end;
  
}


.popup-content {
  background: var(--un-background-color-gray-light);
  border-radius: 12px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15);
  max-width: 680px;
  height: 480px;
  width: 100%;
  padding: 0.3rem 0.6rem;
  margin-top: 52px;
  margin-right: 20px;
  position: relative;
}
 
.hd{ display:flex; align-items:center; justify-content:space-between; padding:5px 16px; }
.ttl{ font-size:16px; font-weight:600; color:var(--text-primary); }
.actions{ display:flex; gap:8px; }
.actions :deep(i){ color:var(--text-primary); font-size:16px; }
 
.popup :deep(.tbs_menu){
  /* box-shadow: inset 0 -2px 0 0 #dadada; */
}


</style>

